var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1C11 0.447715 10.5523 0 10 0C8.89733 0 7.79741 0.127064 6.72206 0.379305C3.57488 1.11753 1.11753 3.57488 0.379308 6.72206C-0.126436 8.87814 -0.126436 11.1219 0.379307 13.278C1.11753 16.4251 3.57488 18.8824 6.72207 19.6207C8.87814 20.1264 11.1219 20.1264 13.278 19.6207C16.4251 18.8824 18.8824 16.4251 19.6207 13.278C19.8729 12.2026 20 11.1028 20 10C20 9.44771 19.5523 9 19 9C18.4477 9 18 9.44771 18 10C18 10.9491 17.8907 11.8957 17.6735 12.8212C17.1088 15.2289 15.2289 17.1088 12.8212 17.6735C10.9655 18.1088 9.03446 18.1088 7.17881 17.6735C4.77113 17.1088 2.89121 15.2289 2.32646 12.8212C1.89118 10.9655 1.89118 9.03446 2.32646 7.1788C2.89121 4.77114 4.77114 2.89121 7.1788 2.32645C8.10432 2.10936 9.05097 2 10 2C10.5523 2 11 1.55228 11 1ZM16.5 1C14.567 1 13 2.56701 13 4.5C13 6.43299 14.567 8 16.5 8C18.433 8 20 6.43299 20 4.5C20 2.56701 18.433 1 16.5 1ZM16.5 3C17.3284 3 18 3.67158 18 4.5C18 5.32842 17.3284 6 16.5 6C15.6716 6 15 5.32842 15 4.5C15 3.67158 15.6716 3 16.5 3Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotify);
export default __webpack_public_path__ + "static/media/icon-notify.b70638613c6850be4ab0811e362b0db9.svg";
export { ForwardRef as ReactComponent };